module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Olivia Drake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("OLIVIA DRAKE")]), _vm._v(" is a "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author who lives in Texas. Her novels have won critical acclaim and numerous industry awards, including the prestigious RITA.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T6zVs9/tc-custom/9781429965033.jpg?1724535441650",
      "alt": "This image is the cover for the book Scandal of the Year, The Heiress In London Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scandal of the Year, The Heiress In London Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Barbara Dawson Smith writing as Olivia Drake"), _c('br'), _c('br'), _vm._v("The youngest of the Crompton heiresses, Blythe yearns to marry into the aristocracy to bolster her family's place in society.  The widowed Duke of Savoy seems to be the perfect choice, yet it's another man who sets her heart to pounding: the new footman, James. He's devilishly handsome and far more fascinating than any of her noble suitors. And he alone has the power to stir her romantic dreams."), _c('br'), _c('br'), _vm._v("Little does she know, however, James Ryding is the true heir to the Crompton fortune. He's posing as a servant in order to find evidence to prove her parents are imposters. By charming Blythe, he hopes to use her to regain his rightful inheritance. But as heat flares between them, he realizes that fulfilling his quest will mean ruining the beautiful, spirited woman who has captured his heart.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0